// robotics = "רובוטיקה וציפוי",
// welding = "ציוד ריתוך",
// painting = "ציוד צביעה",
// construction = "ציוד בניה",
// tools = "כלי עבודה",
// electricTools = "כלי עבודה חשמליים",

export const hebList: HebCategoryType[] = [
  "כלי עבודה חשמליים",
  "כלי עבודה",
  "ציוד בניה",
  "ציוד צביעה",
  "ציוד ריתוך",
  "מסירת כלי תקול",
  "Wera",
  "מוצרים מתכלים",
  "רובוטיקה וציפוי",
];

export type HebCategoryType =
  | "Wera"
  | "מוצרים מתכלים"
  | "מתכלים"
  | "רובוטיקה וציפוי"
  | "מסירת כלי תקול"
  | "ציוד ריתוך"
  | "ציוד צביעה"
  | "ציוד בניה"
  | "כלי עבודה"
  | "כלי עבודה חשמליים"
  | "";

export const engList: CategoryType[] = [
  "electricTools",
  "repair",
  "tools",
  "construction",
  "painting",
  "welding",
  "robotics",
  "wera",
  "consumable",
];

export type CategoryType =
  | "wera"
  | "consumable"
  | "robotics"
  | "welding"
  | "painting"
  | "construction"
  | "tools"
  | "repair"
  | "electricTools"
  | "";

export enum CategoryEnum {
  "Wera" = "wera",
  "מוצרים מתכלים" = "consumable",
  "מתכלים" = "consumable", // Keep existing category links working.
  "רובוטיקה וציפוי" = "welding",
  "ציוד ריתוך" = "welding",
  "ציוד צביעה" = "painting",
  "ציוד בניה" = "construction",
  "כלי עבודה" = "tools",
  "מסירת כלי תקול" = "repair",
  "כלי עבודה חשמליים" = "electricTools",
}
